import {Base} from "@/api/Base"

export class SubjectEdit extends Base {
    path = "subject/edit"
}